import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { format, formatDistanceToNow } from 'date-fns';
import { ro } from 'date-fns/locale';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(date: string | Date): string {
  return format(new Date(date), 'dd/MM/yyyy', { locale: ro });
}

export function formatDateTime(date: string | Date): string {
  return format(new Date(date), 'dd/MM/yyyy HH:mm', { locale: ro });
}

export function timeAgo(date: string | Date): string {
  const d = new Date(date);
  const diffMs = Date.now() - d.getTime();
  if (diffMs < 60_000) return 'acum';

  const result = formatDistanceToNow(d, { locale: ro, addSuffix: false });
  // Shorten "5 minute" → "5m", "2 ore" → "2h", "3 zile" → "3d"
  return result
    .replace(/(\d+)\s*minut[eă]?/, '$1m')
    .replace(/(\d+)\s*or[eăa]?/, '$1h')
    .replace(/(\d+)\s*zil[eă]?/, '$1d')
    .replace(/(\d+)\s*lun[iă]?/, '$1l')
    .replace(/aproximativ\s*/, '')
    .replace(/circa\s*/, '');
}

export function fileSizeLabel(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
